/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSpeechToTextHistoryRequest = {
  sttId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSpeechToTextHistoryRequest$inboundSchema: z.ZodType<
  GetSpeechToTextHistoryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  stt_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "stt_id": "sttId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSpeechToTextHistoryRequest$Outbound = {
  stt_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSpeechToTextHistoryRequest$outboundSchema: z.ZodType<
  GetSpeechToTextHistoryRequest$Outbound,
  z.ZodTypeDef,
  GetSpeechToTextHistoryRequest
> = z.object({
  sttId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sttId: "stt_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSpeechToTextHistoryRequestToJSON(
  getSpeechToTextHistoryRequest: GetSpeechToTextHistoryRequest,
): string {
  return JSON.stringify(
    GetSpeechToTextHistoryRequest$outboundSchema.parse(
      getSpeechToTextHistoryRequest,
    ),
  );
}
export function getSpeechToTextHistoryRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSpeechToTextHistoryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSpeechToTextHistoryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSpeechToTextHistoryRequest' from JSON`,
  );
}
